<template>
  <Atas namasite="AB Tahlil" selamatDatang="Selamat datang di " judul="Pembacaan Tahlil" deskripsi="Tahlil dan doa tahlil "/>
  <main id="main">
    <router-view/>
  </main>
  <Bawah />
</template>

<script>

import Atas from './partial/Header.vue'
import Bawah from './partial/Bawah.vue'

export default {
  name: 'App',
  components: {
    Atas,
    Bawah
  }
}
</script>

<style>

@font-face {
  font-family: "Traditional";
  src: local("Traditional Arabic"),   url('./assets/fonts/tradbdo.woff2') format("woff");
}

@font-face {
  font-family: "mirza";
  src: local("Mirza SemiBold"),   url('./assets/fonts/Mirza-SemiBold.ttf') format("truetype");
}

@font-face {
  font-family: "Type";
  src: local("Arabic Typesetting"),   url('./assets/fonts/arabtype.ttf') format("truetype");
}

@font-face {
  font-family: "alfont";
  src: local("1 alqulub hunadi"),   url('./assets/fonts/alfont.otf') format("truetype");
}
@font-face {
  font-family: "Amiri";
  src: local("Amiri"),   url('./assets/fonts/amiri/Amiri-Bold.ttf') format("truetype");
}

@font-face {
  font-family: "Amiri Quran";
  src: local("Amiri Quran"),   url('./assets/fonts/amiri/AmiriQuran-Regular.ttf') format("truetype");
}

@font-face {
  font-family: "noto";
  src: local("Noto Naskh Arabic"),   url('./assets/fonts/NotoNaskhArabic-Bold.woff2') format("woff2");
}

@font-face {
  font-family: "Kufi";
  src: local("Reem Kufi Fun"),   url('./assets/fonts/ReemKufiFun-Bold.ttf') format("truetype");
}

@font-face {
  font-family: "hafs";
  src: local("KFGQPC HAFS Uthmanic Script"),   url('./assets/fonts/UthmanicHafs.ttf') format("truetype");
}

@font-face {
	font-family: 'Conv_original-hafs';
	src: url('./assets/fonts/hafs/original-hafs.eot');
	src: local('â˜º'), url('./assets/fonts/hafs/original-hafs.woff') format('woff'), url('./assets/fonts/hafs/original-hafs.ttf') format('truetype'), url('./assets/fonts/hafs/original-hafs.svg') format('svg');
	font-weight: normal;
	font-style: normal;
}


</style>